const localStoragePath = 'frescoMapStore'

export default {
	localStoragePath,
}